<template>
  <b-container fluid>
    <PortalNavbar v-if="!isLoggedIn"></PortalNavbar>
    <div class="containern">
      <div class="body-wrapper">
        <div class="body-title">
          <h5 style="color:#9c6d07">Create/Edit Profile</h5>
        </div>
        <div class="body-content">
          <b-card no-body>
            <b-tabs card v-model="tabIndex" @input="checkTab">
              <b-tab title="Signup" key="00" v-if="!isLoggedIn" active>
                <Signup @clicked="enableTabs"></Signup>
              </b-tab>
              <b-tab title="Personal Details"  :disabled="disabled" key="01">
                    <PersonalDetails  ref="tbUserDetail" @clicked="tabIndex++"></PersonalDetails>
              </b-tab>
              <b-tab title="Address Details" :disabled="disabled" key="02">
                <AddressDetails @clicked="tabIndex++"></AddressDetails>
              </b-tab>
              <b-tab title="Family Details" :disabled="disabled" key="03">
                <family @clicked="tabIndex++"></family>
              </b-tab>
              <!-- <b-tab title="Upload Documents" :disabled="disabled" key="04">
                <FormUploads @clicked="tabIndex++"></FormUploads>
              </b-tab> -->
              <b-tab title="Summary" :disabled="disabled" key="05">
                  <Summary ref="summary"></Summary>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import Signup from "@/components/RegistrationLoan/Signup";
import AddressDetails from "@/components/RegistrationLoan/AddressDetails";
// import PersonalDetails from "@/components/RegistrationMathadi/PersonalDetails";
import LendingLoanDetails from "@/components/RegistrationLoan/LendingLoan";
import BankDetails from "@/components/RegistrationLoan/BankDetailsForm";
import Declaration from "@/components/RegistrationLoan/Declaration";
// import Experience from "@/components/RegistrationMathadi/Experience";
import PersonalDetails from "@/components/RegistrationLoan/PersonalDetails";
import FormUploads from "@/components/RegistrationLoan/FileUploadCreatProfile";
import Summary from "@/components/RegistrationLoan/SummaryCreatProfile";
import PortalNavbar from "@/components/PortalNavbar";
import GroupDetails from "@/components/RegistrationLoan/GroupDetails";
import Directors from "@/components/RegistrationLoan/Directors";
import Shareholders from "@/components/RegistrationLoan/Shareholders";
import FormUploadGpLoan from "@/components/RegistrationLoan/FormUploadGpLoan";
import SummaryGroup from "@/components/RegistrationLoan/SummaryGroup";
import family from "@/components/RegistrationLoan/Family"

export default {
  components: {
    Signup,
    AddressDetails,
    PersonalDetails,
    LendingLoanDetails,
    FormUploads,
    BankDetails,
    Declaration,
    GroupDetails,
    Directors,
    Shareholders,
    PortalNavbar,
    FormUploadGpLoan,
    Summary,
    SummaryGroup,
    family
  },
  computed: {
    isLoggedIn() {
      if (this.$store.getters.isLoggedIn) {
        this.disabled = false;
        // alert(this.disabled);
      }
      return this.$store.getters.isLoggedIn;
    },
    getScheme() {
      let x = this.$store.getters.getScheme;
      //console.log (x);
      return x;
    }
  },
  data() {
    return {
      tabIndex: 0,
      disabled: true
    };
  },
  methods: {
    checkTab(n) {
      if (n < 10) {
        this.$refs.summary.CheckStatus();
      }
    },
    enableTabs() {
      this.disabled = false;
      this.tabIndex = 1;
      this.$refs.tbUserDetail.loadSignupUser();
      //this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  box-shadow: none;
  -webkit-box-shadow:none;
  margin-bottom:30px;
  margin-top:30px;
}

.body-title{
  border-bottom:solid 1px #d3d3d3;
  background:#fff;
  padding:15px 25px;
}

.body-title h2{
      color: #000;
    font-weight: bold;
    font-size: 19px;

}

.body-content {
  padding: 25px 10px;
}
.nav > li > a {
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/EditProfile.vue